import { render, staticRenderFns } from "./carousel.vue?vue&type=template&id=4148da1c&scoped=true"
import script from "./carousel.vue?vue&type=script&lang=js"
export * from "./carousel.vue?vue&type=script&lang=js"
import style0 from "./carousel.vue?vue&type=style&index=0&id=4148da1c&prod&lang=scss&scoped=true"
import style1 from "./carousel.vue?vue&type=style&index=1&id=4148da1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4148da1c",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/home/carousel.vue
// module id = null
// module chunks = 